import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';

export default class SymptomRenderer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false
        };
    }

    handleShow = () => {
        if (this.props.data.symptoms && this.props.data.symptoms.length) {
            this.setState({ show: true });
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    render() {
        return (
            <div>
                <button onClick={this.handleShow} className="edit-order-btn">
                    {this.props.data.symptoms && this.props.data.symptoms.length
                        ? this.props.data.symptoms.length === 1 && this.props.data.symptoms[0] === 'None'
                            ? 'None'
                            : this.props.data.symptoms.length +
                              ' Symptom' +
                              (this.props.data.symptoms.length > 1 ? 's' : '')
                        : 'Unknown'}
                </button>
                <ModalStyled
                    size="md"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Symptoms</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.props.data.symptoms &&
                                this.props.data.symptoms.length &&
                                this.props.data.symptoms.map((symptom, index) => {
                                    return <div key={index}>{symptom}</div>;
                                })}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
            </div>
        );
    }
}
